import { Product } from 'modules/contract/types';

export interface Reason {
  id: number,
  title: string,
  description: string
}

export interface ClientContactInformation {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
}

export interface Attachment {
  id: number,
  fileName: string,
  contentType: string,
  fileSize: number
}


export interface Note {
  id: number,
  createdOn: Date,
  message: string,
  attachments: Attachment[]
}

export enum ServiceCallStatus {
  InProgress,
  Resolved
}

export interface ServiceCall {
  id: string,
  externalId: string,
  contractNumber: string,
  clientNumber: string,
  createdOn: Date,
  status: ServiceCallStatus
  product: Product,
  reason: Reason,
  notes: Note[]
}

export interface CreateServiceCallCommand {
  contractNumber: string,
  clientNumber: string,
  productId?: number,
  productName?: string,
  productSku?: string,
  reasonId: number,
  note: string,
  contactInformation: ClientContactInformation
}

export interface FindServiceCallByIdQuery {
  id: string;
  contractNumber: string;
  clientNumber: string;
}

export interface FindServiceCallByContractQuery {
  contractNumber: string;
  clientNumber: string;
}
